import { defineStore } from 'pinia'

import type { SubscriptionsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useSubscriptionsStore = defineStore('subscriptions', {
  state: (): SubscriptionsStore => ({
    loading: false,
    processing: 0,
    subscriptions: [],
    meta: null,
    agents: [],
    discounts: [],
    filterSearch: null,
    filterStatuses: [],
    filterFrom: null,
    filterTo: null,
    currentPage: 1,
    perPage: 25,
    expandedId: null,
    activeModal: null,
    modalSubscriptionId: null,
    retryTarget: null,
  }),
  actions,
  getters,
})
